var _defs, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconError = function SvgIconError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Error_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Icon_Error_svg__cls-1{fill:none;stroke:current}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "Icon_Error_svg__cls-1",
    x: 0.5,
    y: 3.5,
    width: 23,
    height: 17,
    rx: 1,
    ry: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Icon_Error_svg__cls-1",
    d: "M12 8v6M12 16v1"
  })));
};
export default SvgIconError;